<script lang="ts">
  import type { IMenuButton } from "./_types";
  import { createEventDispatcher } from "svelte";

  export let button: IMenuButton;

  $: ({ label, icon, url, color, backgroundColor, callback } = button);
  const dispatch = createEventDispatcher();

  function onClick(ev: event) {
    if (callback) {
      callback();
    }
    dispatch("click");
  }

  $: style =
    (backgroundColor ? `background-color: ${backgroundColor};` : "") +
    (color ? `color: ${color};` : "") +
    (icon ? `grid-template-columns:1.5em auto` : "");
</script>

<a {style} href={url} on:click={onClick} on:keydown={onClick}>
  {#if icon}
    {@const { path, imgAlt } = icon}
    <div class="icon">
      <img src={path} alt={imgAlt} />
    </div>
  {/if}
  <div class="label">
    {@html label}
  </div>
</a>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  a {
    display: grid;
    grid-gap: 0.5em;
    justify-content: center;
    width: 100%;
    position: relative;
    text-decoration: none;
    margin-top: 22px;
    margin-bottom: 26px;
    @include desktop {
      margin-top: 20px;
      margin-bottom: 0px;
      font-weight: 500;
      line-height: 1.875em;
      text-transform: capitalize;
    }
    &:before {
      content: "";
      position: absolute;
      height: 1px;
      top: -22px;
      left: 0;
      right: 0;
      background: #010ebc;
      @include desktop {
        top: -20px;
      }
    }
    .label {
      display: grid;
      align-items: center;
    }
  }
</style>
